
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getOldInterface } from '@/apis/index';
import Swiper from 'swiper';
import { STAT, URLVER } from '@/config/config';
@Component
export default class Analyst extends Vue {
  swiper: any = null;
  followType = -1;
  isFollow = false;
  isSub = 0;
  @Prop() private list!: Array<object>;
  //获取是否关注
  format(id: string) {
    getOldInterface({
      act: 'index',
      con: 'org',
      orgId: id,
    }).then(res => res.data.followType);
  }
  statWithStatus(status: number) {
    this.isSub = 0;
    if (status === 1) {
      this.isSub = 2;
      window.hxmPageStat(`${STAT.noFollow}.guanzhu`, URLVER);
    } else {
      this.isSub = 1;
      window.hxmPageStat(`${STAT.follow}.jianguanzhu`, URLVER);
    }
  }
  industryFollow(item: any, status: number) {
    if (window.getAccount()) {
      this.statWithStatus(status);
      getOldInterface({
        act: 'follow',
        con: 'user',
        type: 4,
        status,
        followId: item.industryId,
      }).then(res => {
        this.$set(this.$followIndustryList, item.industryId, this.isSub);
        this.dealRes(res, item);
      });
    } else {
      window.location.href = 'http://eqhexin/changeUser';
    }
  }
  dealRes(res: any, item: any) {
    if (res.statusCode === 0) {
      this.$set(item, 'followType', !item.followType);
    }
    if (res.statusCode === 300) {
      this.$toast('用户未登录');
    }
  }
  followOrgInstead(item: any, status: number) {
    this.statWithStatus(status);
    getOldInterface({
      act: 'follow',
      con: 'user',
      type: 2,
      status,
      followId: item.orgId,
    }).then(res => {
      this.$set(this.$followOrgList, item.orgId, this.isSub);
      this.dealRes(res, item);
    });
  }
  orgFollow(item: any, status: number) {
    if (window.getAccount()) {
      this.followOrgInstead(item, status);
    } else {
      window.location.href = 'http://eqhexin/changeUser';
    }
  }
  mounted() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    this.swiper = new Swiper('#hotMechanism', {
      slidesPerView: 'auto',
      normalizeSlideIndex: false,
      observer: true,
    });
  }
}
